import React, { Component } from 'react';
import LinksSearchBar from './links/linksSearchBar';
import LinksList from './links/linksList';
import TrendingLinks from './links/trendingLinks';
import { Row, Col } from 'react-bootstrap';

class Links extends Component {

  state = {
    keyword: null,
    isActive: false,
    body: '',
    showListActive: false,
  }

  onSearch = (keyword) => {
    this.setState({keyword: keyword});
  }

  onToggleModal = () => {
    this.setState(prevState => ({ isActive: !prevState.isActive }));
  }

  onHandleHideLinksResults = () => {
    this.setState({ showListActive: false })
  }

  onHandleShowLinksResults = () => {
    this.setState({ showListActive: true })
  }

  render () {
    return (
      <Col className="links-section" sm={12}>
        <Row className="links-container">
          <Col className="links-wrapper trending-links front-links-container" sm={12}>
            <div className="links-search-wrapper">
              <LinksSearchBar className="links-search" 
                onSearch={this.onSearch.bind(this)}
                hideLinksResults={this.onHandleHideLinksResults}
                showLinksResults={this.onHandleShowLinksResults}
              />
            </div>
            <div>
              <LinksList
                keyword={this.state.keyword}
                showList={this.state.showListActive}
                showLinksResults={this.onHandleShowLinksResults}
              />
            </div>
            <div className="title-links-wrapper">
              <h3 className="title-links">Trending Links</h3>
            </div>
              <TrendingLinks />
          </Col>
        </Row>
      </Col>
    );
  }
}

export default Links;


// WEBPACK FOOTER //
// ./src/app/screens/landing/links.js